module.exports = __webpack_public_path__ + "ed8735c27adb521e625717506cfcfb04.eot"


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/media_control/public/Player-Regular.eot
 ** module id = 19
 ** module chunks = 0
 **/